import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../contexts/UserContext';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const Checklist = () => {
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [items,setItems] = useState([]);
  const { user,setUser } = useContext(UserContext);
  const location = useLocation();
  const { itemsReceived } = location.state || { items: [] };
  const [message,setMessage] = useState('')
  const navigate = useNavigate();

  const submitRequest = () => {
    setButtonDisabled(true);
    axios.post(`${process.env.REACT_APP_API_URI}/api/request/create`, { items, zone: user?.zone?._id }, { withCredentials: true })
      .then((response) => {
        if (response.data.success) {
          console.log(response);
          setShowNotification(true);
          const notificationTimer = setTimeout(() => {
            setShowNotification(false);
            navigate('/zc/home',{ state: { itemsReceived: itemsReceived }});
          }, 2500);

          return () => clearTimeout(notificationTimer);
        }
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
      })
  };

  const removeSupplier = (itemForSupplierRemoval) => {
    console.log(itemForSupplierRemoval);
    console.log(items);
    const propertiesToRemove = ['supplier', 'supplierSelected'];
    setItems((prevItems) =>
      prevItems.map((item) =>
        item._id === itemForSupplierRemoval._id
          ? Object.fromEntries(
              Object.entries(item).filter(([key]) => !propertiesToRemove.includes(key))
            )
          : item
      )
    );
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
      if (user) {
        setItems(itemsReceived);
      }
    }
    startup();
  }, [user]);

  return (
    <>
      <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white fixed z-10">
        <button className="flex items-center space-x-2" onClick={() => navigate('/zc/create-request',{ state: { itemsReceived: itemsReceived } })}>
          <span className="text-lg md:text-base">←</span>
        </button>
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Checklist</h4>
      </div>
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
      <div className="space-y-2 pt-[70px]">
        {items?.map((item, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center justify-between mb-4 m-4">
              <div>
                <h2 className="text-sm font-normal">
                  {item.name} - <span className="text-sm text-gray-600 ml-1">{parseFloat(item.quantity).toFixed(2)} {item.unit}</span>
                </h2>
                <p className="text-xs text-gray-600">{item.category}</p>
              </div>
              {item?.purchaseType === "zone" ?
                ((item.item?.supplier?._id || item.supplier?._id) ?
                  <div className='flex flex-row items-center'>
                    <span className='px-4 text-sm text-gray-500 font-semibold'> {item?.item?.supplier?.name || item.supplier?.name}</span>
                    <button onClick={() => removeSupplier(item)} className="w-5 h-5 flex items-center justify-center bg-red-500 text-white rounded-full hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-opacity-50">
                      <svg className="w-3 h-3" fill="none" stroke="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                  :
                  <button onClick={() => navigate("assignSupplier", { state: { items, item } })}
                    className="bg-fmb text-white py-2 px-3 rounded text-sm font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">Check Suppliers</button>
                ) : null
              }
            </div>
            {index < items.length - 1 && <hr className="my-2"/>}
          </React.Fragment>
        ))}
      </div>
      <div className="fixed bottom-0 left-0 mb-16 w-full py-3 px-4 pb-5 bg-fmb border-t border-gray-300">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-sm md:text-lg">{items?.length} Items Added</div>
          {/* <button className="bg-white text-grey-800 font-semibold px-4 py-2 rounded-md text-sm md:text-lg" onClick={submitRequest}>Submit Request</button> */}
          <button className={`font-semibold px-4 py-2 rounded-md text-sm md:text-lg ${isButtonDisabled ? 'bg-gray-400 text-gray-100' : 'bg-white text-black'}`} onClick={submitRequest} disabled={isButtonDisabled}>Submit Request</button>
        </div>
      </div>

      {showNotification && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center space-y-4">
            <div className="animate-bounce">
              <svg className="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-lg font-semibold text-fmb text-center">Request created successfully!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Checklist;